// action types
export const SELECT_NOTIFICATION = "selectNotification";
export const PUSH_NOTIFICATION = "pushNotification";
export const SET_NOTIFICATION_TITLE = "setNotificationTitle";
export const SET_RESERVATIONS_COUNT = "setReservationsCount";
export const SET_QUOTES_COUNT = "setQuotesCount";


// mutation types
export const ADD_NOTIFICATION = "addNotification";
export const REMOVE_NOTIFICATION = "removeNotification";
export const UPDATE_NOTIFICATION_TITLE = "updateNotificationTitle";
export const UPDATE_RESERVATIONS_COUNT = "updateReservationsCount";
export const UPDATE_QUOTES_COUNT = "updateQuotesCount";

import sound from "@/assets/sounds/notification.mp3";

const state = {
  notifications: [],
  reservationsCount: 0,
  quotesCount: 0,
};

const getters = {
  currentNotifications(state) {
    return state.notifications;
  },
  currentReservationsCount(state) {
    return state.reservationsCount;
  },
  currentQuotesCount(state) {
    return state.quotesCount;
  },
};

const actions = {
  [PUSH_NOTIFICATION](context, notification) {
    context.commit(ADD_NOTIFICATION, notification);
    context.commit(UPDATE_NOTIFICATION_TITLE);
  },
  [SELECT_NOTIFICATION](context, requestGuid) {
    context.commit(REMOVE_NOTIFICATION, requestGuid);
    context.commit(UPDATE_NOTIFICATION_TITLE);
  },
  [SET_NOTIFICATION_TITLE](context) {
    context.commit(UPDATE_NOTIFICATION_TITLE);
  },
  [SET_RESERVATIONS_COUNT](context, count) {
    context.commit(UPDATE_RESERVATIONS_COUNT, count);
  },
  [SET_QUOTES_COUNT](context, count) {
    context.commit(UPDATE_QUOTES_COUNT, count);
  },
};

const mutations = {
  [ADD_NOTIFICATION](state, notification) {
    notification.icon = "fas fa-file-invoice-dollar text-success";
    notification.date = new Date();
    state.notifications.unshift(notification);

    var audio = new Audio(sound);
    audio.play();

    // Notification.requestPermission((permission) => {
    //   if (permission === "granted") {
    //     var notif = new Notification("Demande", {
    //       body: `Num: ${notification.reference}`,
    //     });
    //     notif.onclick = function(event) {
    //       event.preventDefault();
    //       window.open(`/requests/detail/${notification.requestPharmacyGuid}`);
    //     };
    //   }
    // });
  },
  [REMOVE_NOTIFICATION](state, requestGuid) {
    state.notifications = state.notifications.filter(
      (x) => x.requestGuid !== requestGuid
    );
  },
  [UPDATE_NOTIFICATION_TITLE](state) {
    var nb = state.notifications.length;
    var title = "Quebec-HD";
    if (nb > 0) {
      title = "(" + state.notifications.length + ") " + title;
    }
    document.title = title;
  },
  [UPDATE_RESERVATIONS_COUNT](state, count) {
    state.reservationsCount = count;
  },
  [UPDATE_QUOTES_COUNT](state, count) {
    state.quotesCount = count;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
